import { NotionProps } from 'notion/types';

const NotionH4: React.FC<NotionProps> = ({ block: { text } }) => (
  <h4 className="font-20 font-medium">{text}</h4>
);

export default NotionH4;
